import ahoy from 'ahoy.js'

document.addEventListener('turbolinks:load', () => {
  const additionalData = JSON.parse(document.querySelector('meta[name=analytics]')?.content || '{}')
  ahoy.trackView(additionalData)
})
